// extracted by mini-css-extract-plugin
export default {"content":"index_content_rsXeq clearfix","col_L":"index_col_L_FRDcq","col_R":"index_col_R_AsdU2","Ad":"index_Ad_3PmFZ"};